<template>
  <div class="dqyxfx-warp">
    <resize-container :tabShow="tabShow">
      <div class="left-content" v-show="tabShow" slot="left">
        <tab-tree :data="viewTreeData" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick" @changeCompany="changeCompany"></tab-tree>
      </div>
      <div class="right-content">
        <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
        <div class="dn-content-bg box1 zt">
          <time-search ref="timeSearch" :control="{data:timeData}" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick">
          </time-search>
        </div>
        <div class="hbC">
          <div class="bh-item dn-content-bg">
            <div class="flex">当前工作日用电量(kWh)</div>
            <div class="flex item-zt">{{onWorkEle}}</div>
          </div>
          <div class="bh-item dn-content-bg">
            <div class="flex">当前非工作用电量(kWh)</div>
            <div class="flex item-zt">{{offWorkEle}}</div>
          </div>
          <div class="bh-item1 dn-content-bg">
            <div class="bh-item-item">
              <div class="flex item-top" :class="workOnClain.clain>0?'big':(workOnClain.clain==0?'equal':'small')">{{workOnClain.clain}}</div>
              <div class="flex">kWh</div>
              <div class="flex item-top" :class="workOnClain.clainRate>0?'big':(workOnClain.clainRate==0?'equal':'small')">{{workOnClain.clainRate}}%</div>
            </div>
            <div class="bh-item-item dn-content-bg">
              <!-- <div class="flex1 item-top"><i class="iconfont icon-shangzhang"></i></div> -->
              <i class="iconfont  flex1 item-top" :class="workOnClain.clainRate>0?'icon-shangzhang big':(workOnClain.clainRate==0?'icon-dengyu equal':'icon-xiajiang small')"></i>
              <div class="flex">工作日环比</div>
            </div>
          </div>
          <div class="bh-item1 dn-content-bg">
            <div class="bh-item-item">
              <div class="flex item-top" :class="workOffClain.clain>0?'big':(workOffClain.clain==0?'equal':'small')">{{workOffClain.clain}}</div>
              <div class="flex">kWh</div>
              <div class="flex item-top" :class="workOffClain.clainRate>0?'big':(workOffClain.clainRate==0?'equal':'small')">{{workOffClain.clainRate}}%</div>
            </div>
            <div class="bh-item-item">
              <i class="iconfont  flex1 item-top" :class="workOffClain.clainRate>0?'icon-shangzhang big':(workOffClain.clainRate==0?'icon-dengyu equal':'icon-xiajiang small')"></i>
              <div class="flex">非工作日环比</div>
            </div>
          </div>
        </div>
        <div class="tab-pane ">
          <div class="tap-echarts ">
            <div class="dn-title-bg tab-top zt">
              <i class="iconfont  icon-youxiang" style="margin-right:5px"></i>
              用电量对比
            </div>
            <div class="tap-center dn-content-bg">
              <div class="echarts">
                <echarts :echartsData="echartsData" :direction="'top'"></echarts>
              </div>
            </div>
          </div>
          <div class="tables table-content dn-content-bg">
            <nk-table id="table" :data="tableData" :noDataTitle="'该时间段暂无数据'" :columns="columns" :border="false" :rowselect="true">
            </nk-table>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import {
  findDataByParam,
} from "@/utils/index.js";
import * as utils from "@/utils/index.js";
import echarts from "./pages/echarts.vue";
import TimeSearch from "@/components/common/TimeSearch.vue";
import TabTree from "@/components/common/TabTree.vue";
import handleData from "@/utils/handleData.js";
import dateTool from "@/utils/dateTool";
import NkTable from "@/components/common/NkTable";
import BtnShow from "@/components/common/BtnShow.vue";
import ResizeContainer from "@/components/common/resizeContainer.vue";
import { isNull, isUndefined } from "util";
let allTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "month",
    label: "月",
  },
  {
    type: "year",
    label: "年",
  },
];
export default {
  components: {
    TimeSearch,
    TabTree,
    echarts,
    NkTable,
    BtnShow,
    ResizeContainer
  },
  data () {
    return {
      tabShow: true,
      viewTreeData: [],
      timeData: allTimeData,
      columns: [],
      tableData: [],
      selectedDate: {
        dateType: 'day',
        startTime: '',
        endTime: ''
      },
      onWorkEle: null,
      offWorkEle: null,
      workOnClain: {//工作日环比
        clain: null,//环比值
        clainRate: 10,//环比率
      },
      workOffClain: {//非工作日环比
        clain: null,//环比值
        clainRate: null,//环比率
      },
      timeOne: true,
      timeTwo: false,
      timeType: 'month',
      echartsData: {},
      dateType: 'day',
      pointInfo: {
        pointNumber: '0',
        pointCode: '100229'
      }
    };
  },
  created () {
  },
  watch: {
  },
  methods: {
    changeCompany (companyId) {
      let vm = this;
      vm.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(companyId, "/nygl/workDayFx", null)
        .then(res => {
          if (res) {
            const viewTreeData = findDataByParam("viewTree", true, res.data);
            vm.viewTreeData = viewTreeData;
          }
        });
    },
    /* 树加载 */
    tabTreeDefault (e) {
      this.selectNodes = [e];
      let time = new Date();
      let startTime = dateTool.format(time, "yyyy-MM-dd ") + "00:00:00";
      time.setDate(time.getDate() + 1);
      let endTime = dateTool.format(time, "yyyy-MM-dd") + " 00:00:00";
      this.selectedDate = {
        dataType: "1",
        dateType: "day",
        startTime: startTime,
        endTime: endTime
      };
      this.TimeControlClick(this.selectedDate);
    },
    /* 树点击 */
    tabTreeClick (e) {
      this.selectNodes = [e];
      this.TimeControlClick(this.selectedDate);
    },
    timeControlChange (e) {
      this.dateType = e.dateType
      this.timeType = e.dateType
      if (e.dateType == 'day') {
        this.timeType = 'date'
      }
    },
    /* 查询 */
    TimeControlClick (e) {
      this.selectedDate = e;
      this.getData();
    },
    async getData () {
      let vm = this
      let measureStr = [];
      let dataStr = [vm.selectedDate.startTime];
      vm.selectNodes.forEach(item => {
        measureStr.push({
          measureId: item.measureId,
          pointNumber: vm.pointInfo.pointNumber,
          pointCode: vm.pointInfo.pointCode
        })
      })
      let res = await vm.$api.tmp.getEnergyAnalysisOfWorkingDay(JSON.stringify(measureStr), JSON.stringify(dataStr), vm.selectedDate.dateType)
      let obj = {
        legend: [],
        xData: [],
        series: [],
        unit: 'kWh'
      }
      let columns = [
        {
          prop: "measureName",
          label: "测量点",
          fixed: "left",
          width: 230,
          show: true,
          align: "left",
        },
        {
          prop: "time",
          label: "时间类型",
          fixed: "left",
          width: 230,
          show: true,
          align: "left",
        },
        {
          prop: "nTotal",
          fixed: "left",
          label: "合计",
          width: 110,
          show: true,
          align: "right",
        },
      ];
      let tableData = []
      if (res.success) {
        let pieData = [{ value: res.data.onWorkEle, name: "上班" }, { value: res.data.offWorkEle, name: "下班" }]
        vm.pieData = pieData
        vm.onWorkEle = Number(res.data.onWorkEle).toFixed(2)
        vm.offWorkEle = Number(res.data.offWorkEle).toFixed(2)
        res.data.workOnClain.clain = Number(res.data.workOnClain.clain).toFixed(2)
        res.data.workOffClain.clain = Number(res.data.workOffClain.clain).toFixed(2)
        res.data.workOnClain.clainRate = Number(res.data.workOnClain.clainRate).toFixed(2)
        res.data.workOffClain.clainRate = Number(res.data.workOffClain.clainRate).toFixed(2)
        vm.workOnClain = res.data.workOnClain
        vm.workOffClain = res.data.workOffClain
        res.data.echartsData[0].workOn.forEach(item => {
          obj.xData.push(vm.matchTime(item.time))
        })
        for (let i = 0; i < res.data.echartsData.length; i++) {
          let item = res.data.echartsData[i]
          let date = null;
          if (vm.selectedDate.dateType == 'day') {
            date = item.date.substring(0, 11)
          } else if (vm.selectedDate.dateType == 'month') {
            date = item.date.substring(0, 7)
          } else {
            date = item.date.substring(0, 4) + '年'
          }
          obj.series.push({
            data: [],
            type: 'bar',
            name: item.measureName + date,
          })
          obj.legend.push(item.measureName + date)
          for (let j = 0; j < item.workOn.length; j++) {
            let temp = item.workOn[j]
            obj.series[i].data.push(Number(temp.value).toFixed(2))
          }
        }
        for (let i = 0; i < res.data.tableData[0].columns.length; i++) {
          let item = res.data.tableData[0].columns[i]
          item = vm.matchTime(item)
          columns.push({
            prop: item,
            label: item,
            show: true,
            width: 110,
            align: "right",
          })
        }

        for (let i = 0; i < res.data.tableData.length; i++) {
          let item = res.data.tableData[i]
          let date = null;
          if (vm.selectedDate.dateType == 'day') {
            date = item.date.substring(0, 11)
          } else if (vm.selectedDate.dateType == 'month') {
            date = item.date.substring(0, 7)
          } else {
            date = item.date.substring(0, 4) + '年'
          }
          for (const key in item.data) {
            item.data[key] = Number(item.data[key]).toFixed(2)
            if (key != 'nTotal') {
              let newKey = vm.matchTime(key)/* 新key格式 */
              let val = item.data[key]
              delete item.data[key]
              item.data[newKey] = val
            }
          }
          tableData.push(item.data)
          tableData[i]["measureName"] = item.measureName
          tableData[i]["time"] = date
        }
      }
      this.columns = columns
      this.echartsData = obj
      vm.tableData = tableData
    },
    /* 匹配时间格式相同的表格 */
    matchTime (item) {
      if (this.selectedDate.dateType == 'day') {
        item = dateTool.format(new Date(item), 'hh时')
      } else if (this.selectedDate.dateType == 'month') {
        item = dateTool.format(new Date(item), 'dd日')
      } else if (this.selectedDate.dateType == 'year') {
        item = dateTool.format(new Date(item), 'MM月')
      }
      return item
    },
  }
};
</script>
<style  scoped lang="scss">
.dqyxfx-warp {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  overflow: hidden;
}
.left-content {
  height: 100%;
  min-width: 200px;
  margin-right: 14px;
}
.right-content {
  height: 100%;
  position: relative;
  display: flex;
  flex-flow: column;
}
.box1 {
  padding: 5px;
  box-sizing: border-box;
  color: #2e3842;
}
.tab-pane {
  width: 100%;
  height: calc(100% - 188px);
  border-radius: 4px;
  .tap-echarts {
    height: 78%;
    margin-bottom: 14px;
    .tab-top {
      height: 45px;
      line-height: 45px;
      padding: 0 14px;
      box-sizing: border-box;
      text-align: left;
      color: #fff;
      font-size: 20px;
      border-radius: 4px 4px 0px 0px;
    }
    .tap-center {
      width: 100%;
      height: calc(100% - 45px);
      .echarts {
        height: 100%;
        width: 100%;
      }
    }
  }
  .tables {
    height: calc(22% - 14px);
    width: 100%;
  }
}
.flex {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex1 {
  flex: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}
.big {
  color: #bc635e;
}
.small {
  color: #7fad7d;
}
.equal {
  color: #ffe793;
}
.hbC {
  height: 100px;
  display: flex;
  color: #acaaae;
  margin: 14px 0;
  .bh-item {
    display: flex;
    width: 310px;
    margin-right: 10px;
    flex-flow: column;
    border-radius: 4px;
    font-size: 18px;
    padding: 12px;
    box-sizing: border-box;
    .bh-item-item {
      display: flex;
      flex: 1;
      flex-flow: column;
    }
    .item-zt {
      font-size: 24px;
      background: #b53b1a;
      border-radius: 4px;
      color: #fff;
    }
  }
  .bh-item1 {
    display: flex;
    width: 310px;
    margin-right: 10px;
    flex-flow: row;
    border-radius: 4px;
    .bh-item-item {
      display: flex;
      flex: 1;
      flex-flow: column;
      .item-top {
        font-size: 22px;
      }
    }
  }
}
</style>